function checkoutErrorMessageKey(error: unknown): string {
  if (error instanceof Error && error.message === 'paymentProcessingFailed') {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'unableToLoadCheckout';
}

function getDescriptionForErrorMessage(errorMessage: string): string {
  switch (errorMessage) {
    case 'unableToLoadCheckout':
      return 'tryAgainLater';
    case 'paymentProcessingFailed':
      return 'reopenAndTryAgain';
    case 'activeSubscriptionExists':
      return 'activeSubscriptionExistsDescription';
    default:
      return 'tryAgainLater';
  }
}

export { checkoutErrorMessageKey, getDescriptionForErrorMessage };
